const prefix = "SYSTEM_";

export const APP_SETTINGS_GET_FAILED = prefix + "APP_SETTINGS_GET_FAILED";
export const APP_SETTINGS_GET_STARTED = prefix + "APP_SETTINGS_GET_STARTED";
export const APP_SETTINGS_GET_SUCCEEDED = prefix + "APP_SETTINGS_GET_SUCCEEDED";
export const CLEAR_LEVY_COLLECTION_FAILED = prefix + "CLEAR_LEVY_COLLECTION_FAILED";
export const CLEAR_LEVY_COLLECTION_STARTED = prefix + "CLEAR_LEVY_COLLECTION_STARTED";
export const CLEAR_LEVY_COLLECTION_SUCCEEDED = prefix + "CLEAR_LEVY_COLLECTION_SUCCEEDED";
export const DISABLE_TESTING_TOOLS = prefix + "DISABLE_TESTING_TOOLS";
export const GLOBAL_ERROR = prefix + "GLOBAL_ERROR";
export const GLOBAL_ERROR_FATAL = prefix + "GLOBAL_ERROR_FATAL";
export const GLOBAL_ERROR_HIDE = prefix + "GLOBAL_ERROR_HIDE";
export const REBUILD_FAILED = prefix + "REBUILD_FAILED";
export const REBUILD_INITIALISE = prefix + "REBUILD_INITIALISE";
export const REBUILD_STARTED = prefix + "REBUILD_STARTED";
export const REBUILD_SUCCEEDED = prefix + "REBUILD_SUCCEEDED";
export const SAP_CONFIGURATION_GET_FAILED = prefix + "SAP_CONFIGURATION_GET_FAILED";
export const SAP_CONFIGURATION_GET_STARTED = prefix + "SAP_CONFIGURATION_GET_STARTED";
export const SAP_CONFIGURATION_GET_SUCCEEDED = prefix + "SAP_CONFIGURATION_GET_SUCCEEDED";
export const SEED_SAMPLE_INVOICES_FAILED = prefix + "SEED_SAMPLE_INVOICES_FAILED";
export const SEED_SAMPLE_INVOICES_STARTED = prefix + "SEED_SAMPLE_INVOICES_STARTED";
export const SEED_SAMPLE_INVOICES_SUCCEEDED = prefix + "SEED_SAMPLE_INVOICES_SUCCEEDED";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const SYSTEM_DETAILS_GET_FAILED = prefix + "SYSTEM_DETAILS_GET_FAILED";
export const SYSTEM_DETAILS_GET_STARTED = prefix + "SYSTEM_DETAILS_GET_STARTED";
export const SYSTEM_DETAILS_GET_SUCCEEDED = prefix + "SYSTEM_DETAILS_GET_SUCCEEDED";
